import axios from 'axios'
export default {
  namespaced: true,
  state: {
    pageList: [],
  },
  mutations: {
    setPageList(state, payload) {
      state.pageList = payload
    },
  },
  getters: {
    pageList: (state) => state.pageList,
  },
  actions: {
    onPageList({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/page',
          method: 'GET',
        })
          .then((resp) => {
            commit('setPageList', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onPageCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/page',
          data,
          method: 'post',
        })
          .then((resp) => {
            dispatch('onPageList')
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onPageShowEdit({ commit, rootState }, { id, language_id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/page/' + id + '/?language_id=' + language_id,
          method: 'GET',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onPageUpdate({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/page/' + id,
          method: 'PUT',
          data,
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onPageDelete({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/page/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
